exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".paywith .checkboxFiPreferred{margin-left:40px}.paywith .singleFi .checkboxFiPreferred.AMEX{margin-left:30px}.paywith .multipleFi .checkboxFiPreferred{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./components/xo-member-components/src/preferred-checkbox/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-member-components/src/preferred-checkbox/styles.less
// module chunks = 1